import { CloudUploadOutlined } from "@ant-design/icons";
import { Button, Form, Select, Typography, notification } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../API";
import useGuardarPrueba from "../../Hooks/useGuardarPrueba";

export default function GuardarPruebaPanel({ atleta, tipoPrueba, repsTabs = [] }) {
    const navigate = useNavigate();
    const { collectReps } = useGuardarPrueba();
    const [cargando, setCargando] = useState(false);
    const [form] = Form.useForm();

    const guardarTodas = async (extra) => {
        const entradas = collectReps();
        const repsGuardar = repsTabs
            .map((tab) => {
                const entry = entradas.find((e) => e.key === tab.key);
                if (!entry?.hasData?.()) return null;
                const payload = entry.getPayload();
                return {
                    key: tab.key,
                    label: tab.label,
                    sistema_de_pesos_y_tiempos: payload.sistema_de_pesos_y_tiempos,
                    fases: payload.fases,
                    parametros: payload.parametros,
                    datos: payload.datos,
                    datos_brutos: payload.datos_brutos,
                };
            })
            .filter(Boolean);

        if (!repsGuardar.length) {
            notification.warning({
                description: "No hay repeticiones con datos. Graba al menos una rep antes de guardar.",
            });
            return;
        }

        const primera = repsGuardar[0];

        try {
            setCargando(true);
            const { data } = await API.post("prueba", {
                ...extra,
                atleta: atleta?._id ?? atleta,
                tipoPrueba,
                reps: repsGuardar,
                sistema_de_pesos_y_tiempos: primera.sistema_de_pesos_y_tiempos,
                fases: primera.fases,
                parametros: primera.parametros,
                datos: primera.datos,
                datos_brutos: primera.datos_brutos,
            });
            notification.success({
                description: `Prueba guardada con ${repsGuardar.length} repetición(es).`,
            });
            const id = data?.doc?._id;
            if (id) navigate(`/prueba/${id}`);
        } catch (err) {
            notification.error({
                description: err?.response?.data?.mensaje || err.toString(),
            });
        } finally {
            setCargando(false);
        }
    };

    return (
        <div style={{ padding: "8px 16px", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
            <Form form={form} layout="inline" onFinish={guardarTodas} style={{ flexWrap: "wrap", gap: 8 }}>
                <Form.Item
                    name="momento"
                    label="Momento"
                    rules={[{ required: true, message: "Seleccione" }]}
                    style={{ marginBottom: 8 }}
                >
                    <Select
                        style={{ minWidth: 100 }}
                        options={[
                            { label: "Único", value: "Único" },
                            { label: "Pre", value: "Pre" },
                            { label: "Post", value: "Post" },
                            { label: "24H", value: "24H" },
                            { label: "48H", value: "48H" },
                            { label: "72H", value: "72H" },
                            { label: "96H", value: "96H" },
                        ]}
                    />
                </Form.Item>
                <Form.Item
                    name="impresion"
                    label="Impresiones"
                    rules={[{ required: true, message: "Ingrese impresiones" }]}
                    style={{ marginBottom: 8, flex: "1 1 200px" }}
                >
                    <TextArea rows={1} autoSize={{ minRows: 1, maxRows: 3 }} />
                </Form.Item>
                <Form.Item style={{ marginBottom: 8 }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={cargando}
                        icon={<CloudUploadOutlined />}
                    >
                        Guardar prueba ({repsTabs.length} rep.)
                    </Button>
                </Form.Item>
            </Form>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                Se guardan todas las repeticiones con datos grabados.
            </Typography.Text>
        </div>
    );
}
